import { refs, domReady, booleanDataset, booleanDatasetValue, dispatchEvent } from '../modules/utils.js';

class CartOverlay extends HTMLElement {
  static get observedAttributes() {
    return ['data-display'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-display') {
      const display = booleanDatasetValue(this, 'display');
      booleanDataset(document.documentElement, 'unscrollable', display);
    }
  }

  async connectedCallback() {
    await domReady();
    this.ignoreNextRender = true;
    this.refs = refs(this);
    this.#listeners();
    this.#itemsListeners();
    this.#loadCart();
    this.setFreeShippingBarWidth();

    // if (window.location.hostname === '127.0.0.1') {
    //   setTimeout(() => booleanDataset(this, 'display', true), 1);
    // }
  }

  #listeners() {
    document.addEventListener('cartlink:overlay', () => booleanDataset(this, 'display', true));
    document.addEventListener('addtocart:added', () => booleanDataset(this, 'display', true));
    document.addEventListener('productcard:added', () => booleanDataset(this, 'display', true));
    document.addEventListener('cart:loaded', () => this.#render());
    document.addEventListener('cart:update', () => this.#loadCart());

    this.refs.close.addEventListener('click', () => booleanDataset(this, 'display', false));
    this.addEventListener('click', (e) => {
      if (e.target === this) {
        booleanDataset(this, 'display', false);
      }
    });
  }

  #itemsListeners() {
    this.refs.items?.forEach(el => {
      const add = el.querySelector('[data-add-ref]');
      const subtract = el.querySelector('[data-subtract-ref]');
      const remove = el.querySelector('[data-remove-ref]');

      add?.addEventListener('click', () => this.#itemAddSubtractQuantity(el.dataset.id, 'add'));
      subtract?.addEventListener('click', () => this.#itemAddSubtractQuantity(el.dataset.id, 'subtract'));
      remove?.addEventListener('click', () => this.#itemAddSubtractQuantity(el.dataset.id, 'remove'));
    });
  }

  async #loadCart() {
    return fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(data => {
        this.cart = data;
        dispatchEvent('cart:loaded', { cart: data });
        return data;
      });
  }

  async #render() {
    if (this.ignoreNextRender) {
      delete this.ignoreNextRender;
      return Promise.resolve();
    }

    return fetch(window.location.href)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cartEl = doc.querySelector('cart-overlay');

        if (cartEl) {
          const buttonEl = doc.querySelector('[data-ref="submitButton"]');
          const wrapperEl = cartEl.querySelector('[data-ref="itemsWrapper"]');
          const countEl = cartEl.querySelector('[data-ref="count"]');
          const subtotalEl = cartEl.querySelector('[data-ref="subtotal"]');
          const freeShippingLabelEl = cartEl.querySelector('[data-ref="freeShippingLabel"]');
          const freeShippingBarEl = cartEl.querySelector('[data-ref="freeShippingBar"]');

          if (wrapperEl) {
            this.refs.itemsWrapper.innerHTML = wrapperEl.innerHTML;
            this.refs.items = Array.from(this.refs.itemsWrapper.querySelectorAll('[data-ref="[items]"]'));;
            this.#itemsListeners();
          }
          if (countEl) {
            this.refs.count.innerHTML = countEl.innerHTML;
          }
          if (subtotalEl) {
            this.refs.subtotal.innerHTML = subtotalEl.innerHTML;
          }
          if (freeShippingLabelEl) {
            this.refs.freeShippingLabel.innerHTML = freeShippingLabelEl.innerHTML;
          }
          if (freeShippingBarEl) {
            this.refs.freeShippingBar.dataset.diff = freeShippingBarEl.dataset.diff;
            this.setFreeShippingBarWidth();
          }
          if (buttonEl) {
            this.refs.submitButton.replaceWith(buttonEl);
            this.refs.submitButton = buttonEl;
          }
        }
      });
  }

  async #itemAddSubtractQuantity(id, operation = 'add') {
    booleanDataset(this, 'disable', true);
    const item = this.cart.items.filter(item => item.id === parseInt(id))[0];
    if (item) {
      let newQuantity = item.quantity;
      if (operation === 'add') {
        newQuantity += 1;
      }
      else if (operation === 'subtract') {
        newQuantity -= 1;
        // if (newQuantity < 1) {
        //   newQuantity = 0;
        // }
      }
      else if (operation === 'remove') {
        newQuantity = 0;
      }
      const updates = { [id]: newQuantity };
      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })
        .then(response => response.json())
        .then((data) => {
          booleanDataset(this, 'disable', false);
          this.cart = data;
          dispatchEvent('cart:loaded', { cart: data });
          return data;
        });
    }
    else {
      return Promise.reject('Item not found');
    }
  }

  setFreeShippingBarWidth() {
    const total = parseFloat(this.refs.freeShippingBar.dataset.total);
    const diff = parseFloat(this.refs.freeShippingBar.dataset.diff);
    let percent = (total - diff) / total * 100;
    if (percent > 100) {
      percent = 100;
    }
    if (percent < 0) {
      percent = 0;
    }
    this.refs.freeShippingBar.style.width = `${percent}%`;
  }
}

customElements.define('cart-overlay', CartOverlay);
